import { map, pipe } from "rxjs";
import { UserAvailability } from "src/app/core/enums/user/user-availability.enum";
import { UserPermission } from "src/app/core/enums/user/user-permission.enum";
import { UserRole } from "src/app/core/enums/user/user-role.enum";
import { UserProfile } from "src/app/core/models/user/user-profile.model";
import { UserDto } from "src/app/infrastructure/lobby-proxy/DTOs/user.dto";
import { userSummaryDtoToUser } from "./user-dto.mapping";


export const mapUserDtoToUserProfile = pipe(
    map((source: UserDto) => userDtoToUserProfile(source))
)

export function userDtoToUserProfile(source: UserDto): UserProfile {
    return {
        ...userSummaryDtoToUser(source),
        phone: source.cellulare,

        activationDate: source.dataAttivazione ? new Date(source.dataAttivazione!) : null,
        endDateReport: source.dataFineRapporto ? new Date(source.dataFineRapporto!) : null,
        isHidden: source.isNascosto,
        isDeleted: source.isDeleted,
        isBlocked: source.isBloccato,
        isActive: source.isAttivo,

        idArea: source.idArea,
        area: source.area?.area ?? null,
        roles: source.ruoli?.map(r => UserRole[r as keyof typeof UserRole]) ?? [],
        permissions: source.permissions?.map(r => UserPermission[r as keyof typeof UserPermission]) ?? [],
        properties: source.properties,

        isConsultant: source.isConsulente,
        canManagePermissions: source.canManagePermissions,
        wantReceiveOffers: source.wantReceiveOffers,

        interdiction: source.interdiction ? {
            reason: source.interdiction.reason,
            expiration: new Date(source.interdiction.expiration)
        } : null,

        availability: source.interdiction ? UserAvailability.Interdict :
            (source.isBloccato || source.isDeleted || source.isNascosto) ? UserAvailability.Unavailable : UserAvailability.Available,

        version: source.version,
    } as UserProfile
}